var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5C4.40625 1.5 1.5 4.40625 1.5 8C1.5 11.5938 4.40625 14.5 8 14.5C11.5938 14.5 14.5 11.5938 14.5 8C14.5 4.40625 11.5938 1.5 8 1.5ZM8 16C3.59375 16 0 12.4062 0 8C0 3.59375 3.59375 0 8 0C12.4062 0 16 3.59375 16 8C16 12.4062 12.4062 16 8 16ZM7.25 10.75V8.75H5.25C4.84375 8.75 4.5 8.40625 4.5 8C4.5 7.59375 4.84375 7.25 5.25 7.25H7.25V5.25C7.25 4.84375 7.59375 4.5 8 4.5C8.40625 4.5 8.75 4.84375 8.75 5.25V7.25H10.75C11.1562 7.25 11.5 7.59375 11.5 8C11.5 8.40625 11.1562 8.75 10.75 8.75H8.75V10.75C8.75 11.1562 8.40625 11.5 8 11.5C7.59375 11.5 7.25 11.1562 7.25 10.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.33d9349f4b0f959cd5ebddc3e7141348.svg";
export { ForwardRef as ReactComponent };